import { memo } from 'react';

import type { ContentBlock } from '@/types/newsService';

interface Props {
  block: ContentBlock;
}

export const ImageBlock = memo(function ImageBlock({ block }: Props) {
  if (!block.imageUrl) return null;

  return (
    <figure className="my-3">
      <img
        src={block.thumbnailUrl || block.imageUrl}
        alt={block.alt ?? ''}
        loading="lazy"
        className="h-[200px] w-full rounded-xl object-cover"
      />
      {block.caption ? (
        <figcaption className="mt-1.5 text-center text-xs italic text-fg-muted">
          {block.caption}
        </figcaption>
      ) : null}
    </figure>
  );
});
